<div class="{uiClasses}label" part="label">
  {#if text}
    {text}
  {else}
    {>slot}
  {/if}
  {#if detail}
    <span class="detail">{detail}</span>
  {/if}
</div>
